import { m } from '@sohanscript/i18n';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { Hydrate } from '@tanstack/react-start';
import { idle } from '@tanstack/react-start/hydration';
import { Cta } from '#/components/cta.tsx';
import { GoToTop } from '#/components/layout/goto-top.tsx';
import { GITHUB_LINK } from '#/components/layout/goto-top.utils.ts';
import { ServiceBreadcrumb } from '@/components/services/service-breadcrumb';
import { ServiceDetails } from '@/components/services/service-details';
import { ServiceNav } from '@/components/services/service-nav';
import { seo, siteConfig } from '@/lib/config/site';
import { localizeServiceBySlug } from '@/lib/data/services-i18n';

export const Route = createFileRoute('/_main/build/$slug')({
	component: ServiceDetailPage,
	loader({ params }) {
		const service = localizeServiceBySlug(params.slug);
		if (!service) throw notFound({ data: { message: m.svc_not_found() } });
		return { service };
	},
	head({ loaderData, params }) {
		const service = loaderData?.service;
		const tags = seo({
			title: service?.title ?? params.slug,
			description: service?.tagline,
			url: `${siteConfig.canonical}/build/${params.slug}`,
		});
		return { meta: tags.meta, links: tags.links };
	},
});

function ServiceDetailPage() {
	const { slug } = Route.useParams();
	return (
		<>
			<ServiceBreadcrumb />
			<section className="container pt-16 pb-20 lg:py-20">
				<ServiceDetails slug={slug} />
				<ServiceNav className="py-10" />
			</section>
			<Hydrate when={idle()}>
				<Cta className="container" />
			</Hydrate>
			<GoToTop
				links={[
					{
						href: '/services',
						icon: 'lucide:layout-grid',
						label: m.svc_all(),
					},
					{
						href: '#~_scope',
						icon: 'lucide:box',
						label: '~/scope',
					},
					{
						href: '#~_process',
						icon: 'lucide:workflow',
						label: '~/process',
					},
					{
						href: '#~_work-case-study',
						icon: 'lucide:flask-conical',
						label: '~/work-case-study',
					},
					GITHUB_LINK,
				]}
			/>
		</>
	);
}
